// removed by extract-text-webpack-plugin
module.exports = {"Alumni":"src-components-Home-Alumni----Alumni-module---Alumni---pYjRC","Alumni__Wrapper":"src-components-Home-Alumni----Alumni-module---Alumni__Wrapper---1xT-B","Alumni__Cards":"src-components-Home-Alumni----Alumni-module---Alumni__Cards---2PFCh","Alumni__Card":"src-components-Home-Alumni----Alumni-module---Alumni__Card---3ohgN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Alumni/Alumni.module.scss
// module id = 375
// module chunks = 128375257210180 243680507791214